import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-bang1',
  standalone: true,
  templateUrl: './bang1.component.html',
  styleUrls: ['./bang1.component.scss'],
  imports: [HighchartsChartModule, MdbFormsModule, MdbSelectModule,
    MdbTableModule, CommonModule, MdbCheckboxModule,
  ReactiveFormsModule]
})
export class Bang1Component implements OnInit {
  form : UntypedFormGroup
  mercati = []
  totale = []
  totalePask = []
  positiveB = []
  positiveS = []
  arrayPask = [2, 3, 5, 7, 9, 10, 15, 20, 25, 50, 100]
  versoOperazione = ["buy", "sell"]
  url = this.service.url
  isHighcharts = typeof Highcharts === 'object';
  Highcharts: typeof Highcharts = Highcharts; 
  chartConstructor: string = 'chart'; 
  chartOptions: Highcharts.Options = {
      series: [{
      data: this.totale,
      type: 'line'
    }]
  } 


  constructor(private service: FrattaleService) {
     this.form = new UntypedFormGroup({
      mkt: new UntypedFormControl("eurusd", Validators.required),
      stoploss: new UntypedFormControl(50, Validators.required),
      numerobarre: new UntypedFormControl(4, Validators.required),
      seriebarre: new UntypedFormControl(20, Validators.required),
      barraminima: new UntypedFormControl(0.002, Validators.required),
      chkTP: new UntypedFormControl(true),
      TP: new UntypedFormControl(0.02, Validators.required),
      verso: new UntypedFormControl(this.versoOperazione[0], Validators.required),
      pask: new UntypedFormControl(this.arrayPask[1], Validators.required),
    }); 
  }
 
  get mkt() { return this.form.get('mkt') as UntypedFormControl }
  get stoploss() { return this.form.get('stoploss') as UntypedFormControl }
  get numerobarre() { return this.form.get('numerobarre') as UntypedFormControl }
  get seriebarre() { return this.form.get('seriebarre') as UntypedFormControl }
  get barraminima() { return this.form.get('barraminima') as UntypedFormControl }
  get chkTP() { return this.form.get('chkTP') as UntypedFormControl }
  get tp() { return this.form.get('tp') as UntypedFormControl }
  get verso() { return this.form.get('verso') as UntypedFormControl }
  get pask() { return this.form.get('pask') as UntypedFormControl }
 

  ngOnInit(): void {
    //this.TP.disable()
    this.service.getMarketsSymbols().subscribe(
      (m: any) => {
        this.mercati = m.data
      }
    )
  }

  calcola() {
    this.service.bangType1(this.url).subscribe(
      (dati: any) => {
        console.log(dati)
        this.positiveB = dati.posB
        this.positiveS = dati.posS
        this.totale = dati.totali
        this.totalePask = dati.totaliPask
    })}
    check() {
      //this.TP.disable()
      if (this.tp.disabled) {
        this.tp.enable()
      } else {
        this.tp.patchValue(null)
        this.tp.disable()
      }
    }
}
